import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { applyTheme } from '../utils/colorGenerator';
import { applyBranding } from '../utils/branding';

const DEFAULT_ORGANIZATION = {
  stammName: 'Pfadfinder Wutöschingen',
  stammFullName: 'Pfadfinder Wutöschingen',
  bundName: 'Pfadfinderbund Horizonte e.V.',
  dachverband: 'DPV - Deutscher Pfadfinderverband',
  location: 'Wutöschingen',
  locationBadge: 'Wutöschingen, DE',
  motto: 'Natur erleben, Freunde finden, fürs Leben lernen.',
  registrationUrl: 'https://on.campflow.de/pfadfinderbund-horizonte/mitgliedsantrag',
  instagramUrl: 'https://www.instagram.com/pfadfinder_wutoeschingen/',
  whatsappUrl: 'https://chat.whatsapp.com/Ewa1whIq0Fc2B328CD593z',
  contactEmail: 'info@pfadfinder-wutoeschingen.de',
  bundUrl: 'https://pbhorizonte.de/',
  bundLogoUrl: 'https://wsrv.nl/?url=https%3A%2F%2Fpbhorizonte.de%2Fwp-content%2Fuploads%2F2021%2F02%2Fcropped-PBH-freigestellt.png&w=300&output=webp',
  footerText: 'Wir entdecken die Welt, schützen die Natur und stärken die Gemeinschaft. Komm vorbei und erlebe dein nächstes Abenteuer mit uns!',
  footerTagline: 'Handgemacht mit ❤️ für die Jugend von der Jugend.',
  faviconUrl: '',
  tabTitle: 'Pfadfinder Wutöschingen',
  dashboardTabTitle: 'Dashboard | Pfadfinder Wutöschingen',
  dashboardWelcomeSubtitle: 'Eingeloggt als'
};

const SettingsContext = createContext({
  settings: null,
  organization: DEFAULT_ORGANIZATION,
  loading: true,
  refreshSettings: async () => {}
});

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(null);
  const [organization, setOrganization] = useState(DEFAULT_ORGANIZATION);
  const [loading, setLoading] = useState(true);

  const fetchSettings = async () => {
    try {
      const apiUrl = process.env.REACT_APP_API_URL || 'https://pfadfinder-public-api.suppenchris.workers.dev/api';
      const cleanUrl = apiUrl.replace(/\/+$/, '');
      const { data } = await axios.get(`${cleanUrl}/settings/homepage`);
      if (data) {
        setSettings(data);
        if (data.organization) {
          setOrganization(prev => ({ ...prev, ...data.organization }));
          applyBranding({
            title: data.organization.tabTitle || data.organization.stammName,
            faviconUrl: data.organization.faviconUrl
          });
        }
        if (data.colorTheme) {
          applyTheme(data.colorTheme);
        }
      }
    } catch (err) {
      console.warn('Could not load dynamic settings from API, using default org:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSettings();
  }, []);

  return (
    <SettingsContext.Provider value={{ settings, organization, loading, refreshSettings: fetchSettings }}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => useContext(SettingsContext);

export default SettingsContext;
